export function formatTimestampedFileName(name: string, locale: string): string {
    const now = new Date();
    const date = new Intl.DateTimeFormat(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    })
        .format(now)
        .replace(/[^\d]/g, "-");

    const time = new Intl.DateTimeFormat(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    })
        .format(now)
        .replace(/[^\d]/g, "-");

    return `${name}_${date}_${time}`;
}
